// removed by extract-text-webpack-plugin
module.exports = {"over_body":"_3dLMtsbrJR5Vk-5WNrRn17","skin_pane":"jnHNA4j9aQkaRVQhFPrtn","moveIn":"_3pR4RQdDLgETh_ERZw2By0","skin_item":"_1cvXpv629RkhFdLbOsU1y5","mainContainer":"_3B5DvAIEEjz4YQvoS0OJVW","backgroundImage":"_35uaT05P04Ku2alCwqtij7","header":"_2ZAQi-fL_apCd2RL93dDc-","logo":"_36Z1wTXX_ZtMF-Grr_W8q-","container":"rRDCWTNTlTGh7AKl8oq8Y","tab_style":"IBaH7LulQ_ayOolioOHwh","change_skin_button":"_14lXAulqoR3hxK03DecFiA","moveOut":"y-zPSzuFqhQWe6bBhHYIj"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.less
// module id = 451
// module chunks = 0